import { withStyles } from '@material-ui/core';

import BookmarkCheck from './component';
import styles from './styles';

export default withStyles(styles)(BookmarkCheck);
